import React, { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import axios from "axios";
import Table from 'react-bootstrap/Table';
import loading1 from '../../assets/img/loading-gif.gif';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
// import { UserOutlined } from '@ant-design/icons';
// import { PhoneOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Logo from '../../assets/img/logo.png';
import $ from 'jquery';
import { fetchwalletamount } from '../../common.js';
import { Container } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { Button, Form, Input, message, Space, Modal } from 'antd';
import Withdrawhistory from './Withdrawhistory';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { toast } from 'react-toastify';



export default function Wallet() {
  const [walletAmount, setWalletAmount] = useState(null);

  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  const [selectedOption, setSelectedOption] = useState(true);
  const [amountvalue, setvalue] = useState("");
  const [msg, setmsg] = useState("");
  const [winAmount, setwinAmount] = useState("");
  const [point, setPoint] = useState("");
  const [accountno, setAccountno] = useState("");
  const [accountnoconf, setAccountnoconf] = useState("");
  const [ifcecode, setIfcecode] = useState("");
  const [ifcecodeconf, setIfcecodeconf] = useState("");
  const [msgwallet, setmsgwallet] = useState("");
  const [users, setUsers] = useState([]);
  const [user, setUsers1] = useState([]);
  const navigate = useNavigate();
  const [loadingbutton, setLoadingbutton] = useState(false);

  const [inputValue, setInputValue] = useState('');
  const [userData, setUserData] = useState(null);
  const [depositvideoink, setdepositvideoink] = useState(null);
  const [withdraw_video_link, setwithdraw_video_link] = useState(null);
  console.warn("data", depositvideoink)
  const [appmanager, setAppmanager] = useState(null);
  const [minredeem, setMinredeem] = useState(null);
  const [Deposit, setDeposit] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [winamount, setwinamount] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loadingwithdraw, setLoadingwithdraw] = useState(false);
  const [loadingwallet, setLoadingwallet] = useState(false);
  const [banned, setbanned] = useState([]);
  const [withdrawotp, setwithdrawotp] = useState([]);

  // alert(withdrawotp)

  const changevalue = (e) => {
    setvalue(e.target.value)
  }
  const handleButtonClickdeposit = (amount) => {
    // setSelectedAmount(amount);
    setInputValuedeposit(amount);
  };

  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const [form] = Form.useForm();

  const onFinish = () => {
    // message.success('Submit success!');
  };
  const formatTime = (time) => {
    if (!time) return "--";

    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(Number(hours), Number(minutes));

    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  const onFinishFailed = () => {
    message.error('Submit failed!');
  };

  useEffect(() => {
    // loaduser();
    loaduser1();
    loaduser11();
    getuser();
    app_manager();
  }, [])



  const getuser = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      const url = `${process.env.REACT_APP_API_URL}/POM_get_user_profile`;

      // JSON request payload
      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id
      };

      // Sending request as JSON
      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      // Axios automatically parses JSON response
      const objectRes = response.data;
      setdepositvideoink(objectRes.deposit_video_link);
      setwithdraw_video_link(objectRes.withdraw_video_link);


      // Extract and update state
      if (objectRes) {
        setbanned(objectRes.banned);
        setPoint(objectRes.tr_value);
        setAccountno(objectRes.account_no);
        setAccountnoconf(objectRes.account_no);
        setIfcecode(objectRes.ifsc_code);
        setIfcecodeconf(objectRes.ifsc_code);
        setUserData(objectRes);

        console.warn("Banned:", objectRes.banned);
        console.warn("Account No:", objectRes.account_no);
        console.warn("IFSC Code:", objectRes.ifsc_code);
      }

    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const app_manager = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      // let url = `${process.env.REACT_APP_API_URL}/POM_app_manager.php`;
      let url = `${process.env.REACT_APP_API_URL}/app-manager`;

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id
      };

      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (response?.data?.data) {
        const responseData = response.data.data;
        setwithdrawotp(responseData.withdraw_otp || "");

        setMinredeem(responseData.min_redeem || 0);
        setDeposit(responseData.min_deposit || 0);

        setAppmanager(responseData);
      } else {
        console.error("API Error: Response data is undefined");
      }
    } catch (error) {
      console.error("Error fetching app manager data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const loaduser = async () => {
  //   try {
  //     const user_id = localStorage.getItem("userid");
  //     const dev_id = localStorage.getItem("dev_id");
  //     setLoadingwallet(true);

  //     let url = `${process.env.REACT_APP_API_URL}/wallet-report`;

  //     const requestData = {
  //       app_id: process.env.REACT_APP_API_ID,
  //       user_id: user_id,
  //       dev_id: dev_id
  //     };

  //     const response = await axios.post(url, requestData, {
  //       headers: {
  //         "Content-Type": "application/json"
  //       }
  //     });

  //     if (response?.data) {
  //       setmsgwallet(response.data.message);
  //       setwinamount(response.data.winAmount || 0);
  //       setUsers(response.data.data || []);
  //     } else {
  //       console.error("API Error: Response data is undefined");
  //     }

  //   } catch (error) {
  //     console.error("Error loading wallet history:", error);
  //   } finally {
  //     setLoadingwallet(false);
  //   }
  // };


  const loaduser1 = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");
      setLoadingwithdraw(true);

      // let url = `${process.env.REACT_APP_API_URL}/POM_withdraw_history.php`;
      let url = `${process.env.REACT_APP_API_URL}/withdrawl-history`;

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id
      };

      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (response?.data) {
        setmsg(response.data.message);
        setwinAmount(response.data.winAmount);
        setUsers1(response.data.data || []);
      } else {
        console.error("API Error: Response data is undefined");
      }

    } catch (error) {
      console.error("Error loading withdrawal history:", error);
    } finally {
      setLoadingwithdraw(false);
    }
  };


  const user_id = localStorage.getItem("userid");
  const dev_id = localStorage.getItem("dev_id");
  const [inputValuedeposit, setInputValuedeposit] = useState('');



  const handleDeposit = () => {
    if (banned === '1') {
      // alert('lll')
      setLoading2(true);
      setTimeout(() => {
        setLoading2(false);
      }, 90000);
      return;
    }
    if (parseInt(Deposit) > parseInt(inputValuedeposit)) {
      // alert('5')
      // console.warn(setminibet);
      toast.error(`Minimum Redeem Amount ${appmanager.min_deposit}`);
      return;
    }
    if (inputValuedeposit) {
      const apiUrl = `https://adminvip.shreejii.club/public/payment-getway?name=${userData.name}&userid=${user_id}&amount=${inputValuedeposit}&contact=${userData.mob}&getaway=razorpay`;
      window.location.href = apiUrl;
    } else {

    }
  };

  // Withdrawal Api

  const [bankName, setBankName] = useState('');
  const [accountHolderName, setAccountHolderName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [upiid, setupiid] = useState('');
  const [inputError, setInputError] = useState(false);
  const [bankNameError, setBankNameError] = useState(false);
  const [accountHolderNameError, setAccountHolderNameError] = useState(false);
  const [accountNumberError, setAccountNumberError] = useState(false);
  const [ifscCodeError, setIfscCodeError] = useState(false);
  const [mobilnumbererror, setMobileNumberError] = useState(false);
  const [amounttrerror, setAmountError] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);

  const [accountNumberConfirmation, setAccountNumberConfirmation] = useState('');
  const [ifscCodeConfirmation, setIfscCodeConfirmation] = useState('');
  //  const OnDobInputChange = (e) => {
  //     const newDate = e.target.value;
  //     dateOfBtUpdate(newDate);
  //   };



  const handleWithdrawal = async () => {



    try {
      setLoadingbutton(true);
      setShowSubmitButton(true);
      setInputError(false);
      setBankNameError(false);
      setAccountHolderNameError(false);
      setAccountNumberError(false);
      setIfscCodeError(false);

      // Validate account number and IFSC code confirmation
      if (accountNumber !== accountNumberConfirmation) {
        toast.error("Account number and confirmation do not match");
        return;
      }

      if (ifscCode !== ifscCodeConfirmation) {
        toast.error("IFSC code and confirmation do not match");
        return;
      }

      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        dev_id: dev_id,
        user_id: user_id,
        otp: otp,
        amount: inputValue || point,
        bank_name: bankName,
        account_holder_name: accountHolderName,
        account_number: accountNumber || accountno,
        ifsc_code: ifscCode || ifcecode,
        upiid: upiid,
      };

      // let url = `${process.env.REACT_APP_API_URL}/POM_deduct_withdrawal.php`;
      let url = `${process.env.REACT_APP_API_URL}/deduct-withdrawweb`;

      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      // if (inputValue === "") {
      //   withReactContent(Swal).fire({
      //     title: "Amount is required",
      //     icon: 'error',
      //     timer: 2000
      //   });
      //   return; // Stop further execution
      // }
      // if (response?.data?.success === "1" || response?.data?.success === "4") {
      //   getuser();
      //   setLoading3(false);

      //   withReactContent(Swal).fire({
      //     title: response.data.message,
      //     icon: 'success',
      //     timer: 2000
      //   }).then(() => {
      //     sessionStorage.setItem("acc_no", response.data.account_no);
      //     sessionStorage.setItem("ifce_code", response.data.ifsc_code);
      //   });

      // }
      if (response?.data?.success === "1") {
        getuser();
        setLoading3(false);

        withReactContent(Swal).fire({
          title: response.data.message,
          icon: 'success',
          timer: 3000
        }).then(() => {
          sessionStorage.setItem("acc_no", response.data.account_no);
          sessionStorage.setItem("ifce_code", response.data.ifsc_code);

        });

      } else if (response?.data?.success === "4") {
        setLoading3(false);

        withReactContent(Swal).fire({
          title: response.data.message,
          icon: 'error',
          timer: 3000
        });



      }
      else {
        withReactContent(Swal).fire({
          title: response.data.message,
          timer: 3000
        });
      }

    } catch (error) {
      console.error("Error handling withdrawal:", error);
    } finally {
      setLoadingbutton(false);
      setShowSubmitButton(false);
    }
  };
  const handleWithdrawalupi = async () => {



    try {
      setLoadingbutton(true);
      setShowSubmitButton(true);
      setInputError(false);
      setBankNameError(false);
      setAccountHolderNameError(false);
      setAccountNumberError(false);
      setIfscCodeError(false);

      // Validate account number and IFSC code confirmation


      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        dev_id: dev_id,
        user_id: user_id,
        amount: inputValue || point,

        upi_id: upiid,
      };

      // let url = `${process.env.REACT_APP_API_URL}/POM_deduct_withdrawal.php`;
      let url = `${process.env.REACT_APP_API_URL}/deduct-withdrawUpiweb`;

      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      // if (inputValue === "") {
      //   withReactContent(Swal).fire({
      //     title: "Amount is required",
      //     icon: 'error',
      //     timer: 2000
      //   });
      //   return; // Stop further execution
      // }
      // if (response?.data?.success === "1" || response?.data?.success === "4") {
      //   getuser();
      //   setLoading3(false);

      //   withReactContent(Swal).fire({
      //     title: response.data.message,
      //     icon: 'success',
      //     timer: 2000
      //   }).then(() => {
      //     sessionStorage.setItem("acc_no", response.data.account_no);
      //     sessionStorage.setItem("ifce_code", response.data.ifsc_code);
      //   });

      // }
      if (response?.data?.success === "1") {
        getuser();
        setLoading3(false);

        withReactContent(Swal).fire({
          title: response.data.message,
          icon: 'success',
          timer: 3000
        }).then(() => {
          sessionStorage.setItem("acc_no", response.data.account_no);
          sessionStorage.setItem("ifce_code", response.data.ifsc_code);
        });

      } else if (response?.data?.success === "4") {
        setLoading3(false);

        withReactContent(Swal).fire({
          title: response.data.message,
          icon: 'error',
          timer: 3000
        });



      }
      else {
        withReactContent(Swal).fire({
          title: response.data.message,
          timer: 3000
        });
      }

    } catch (error) {
      console.error("Error handling withdrawal:", error);
    } finally {
      setLoadingbutton(false);
      setShowSubmitButton(false);
    }
  };


  const handleButtonClick = (amount) => {

    setInputValue(amount);
  };



  // ------transferpoints Api ------- //


  const [mobilnumber, setmobilNumber] = useState('');
  const [amounttr, setAmounttr] = useState('');

  const OnnumberChange = (e) => {
    const mobilnumbers = e.target.value;
    setmobilNumber(mobilnumbers);
  };

  const OnamountChange = (e) => {
    const amount = e.target.value;
    setAmounttr(amount);
  };

  const transferpoints = async () => {

    const errors = [];

    const mobilNumberRegex = /^\d+$/;
    const amountRegex = /^\d+$/;

    if (!mobilNumberRegex.test(mobilnumber)) {
      setMobileNumberError(true);
      errors.push('Please enter a valid number');
    }

    if (!amountRegex.test(amounttr)) {
      setAmountError(true);
      errors.push('Please enter a valid Amount');
    }


    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");
      const formData = new FormData();
      formData.append('rec_mob', mobilnumber);
      formData.append('amount', amounttr);
      formData.append('app_id', process.env.REACT_APP_API_ID);
      formData.append('user_id', user_id);
      formData.append('devName', dev_id);
      // formData.append('devName', 'web');
      setLoading2(false);
      let url = `${process.env.REACT_APP_API_URL}/POM_transfer.php`;
      const config = {
        method: 'POST',
        url: url,
        data: formData,
      };

      axios.post(url, formData, config)
        .then(function (response) {
          const res = JSON.stringify(response.data);
          if (response.data.status == 1) {
            // console.warn('ddddddd');
            getuser();
            // loaduser();
            setLoading2(false);
            // setShowSubmitButton(false);
            setOpen(false);

            toast.success(response.data.message, {
              onClose: () => {
                // Reload the window after the toast message is closed
                // window.location.reload();
              }
            });
            // const MySwal = withReactContent(Swal)
            // MySwal.fire({
            //   title: response.data.message,
            //   icon: 'success',
            //   timer: 2500
            // })
          } else {
            toast.error(response.data.message);
          }
        });
    } catch (error) {
      console.error('User Name Update:', error);
      // toast.error('An error occurred while updating username. Please try again later.');
    }
    // setLoading2(true);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  // const showModalnew = () => {
  //   setIsModalOpen(true);
  // };

  // const handleOknew = () => {
  //   setIsModalOpen(false);
  // };

  const handleCancelnew = () => {
    setIsModalOpen(false);
  };


  const [otp, setOtp] = useState(''); // Initial state for OTP
  console.warn(otp)

  const withdrawootp = async () => {

    if (!accountno) {
      if (accountNumber == "") {

        const MySwal = withReactContent(Swal);
        MySwal.fire({
          title: 'Please fill out the required fields',
          timer: 1000,
          icon: 'error'
        });
        return;
      }
    }


    const errors = [];

    const mobilNumberRegex = /^\d+$/;
    const amountRegex = /^\d+$/;

    if (accountNumber !== accountNumberConfirmation) {
      // Show an error message or handle the mismatch appropriately
      toast.error("Account number and confirmation do not match");
      return;
    }


    // Check if the entered IFSC code matches the confirmation
    if (ifscCode !== ifscCodeConfirmation) {
      // Show an error message or handle the mismatch appropriately
      toast.error("IFSC code and confirmation do not match");
      return;
    }

    if (!mobilNumberRegex.test(mobilnumber)) {
      setMobileNumberError(true);
      errors.push('Please enter a valid number');
    }

    if (!amountRegex.test(amounttr)) {
      setAmountError(true);
      errors.push('Please enter a valid Amount');
    }


    setIsModalOpen(true);


    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");

    let url = `${process.env.REACT_APP_API_URL}/POM_withdrawotp.php`;
    const formData = new FormData();
    formData.append('app_id', process.env.REACT_APP_API_ID);
    formData.append('user_id', user_id);
    formData.append('dev_id', dev_id);
    var config = {
      method: 'POST',
      url: url,
      body: formData,
    };

    try {
      const response = await axios.post(url, formData, config);
      const responseData = response.data.data;
      const responseDataaaa = response.data.data.withdraw_otp;
      setwithdrawotp(responseDataaaa)

      if (responseData) {
        const { min_redeem, min_deposit } = responseData;
        setMinredeem(min_redeem);
        setDeposit(min_deposit);

        const res = JSON.stringify(responseData);
        const objectRes = JSON.parse(res);
        setAppmanager(objectRes);
        setIsLoading(false);
      } else {
        console.error("API Error: Response data is undefined");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const [activeTab, setActiveTab] = useState('upi');


  //////////welet report/////////////////////

  const [paginate, setpaginate] = useState(1);
  const [loadbuttonshow, setloadbuttonshow] = useState();
  let firstNumbers = [];

  const shoot = () => {
    loaduser11();
  };

  const loaduser11 = async () => {
    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");

    let url = `${process.env.REACT_APP_API_URL}/wallet-report`;
    const requestBody = {
      app_id: process.env.REACT_APP_API_ID,
      user_id: user_id,
      dev_id: dev_id,
      paginate: paginate,
    };

    axios
      .post(url, requestBody)
      .then(function (response) {
        const msgwallet = response.data.data;
        setmsgwallet(msgwallet);
        console.warn("responce data for data", response);

        if (response.data.success === "1") {
          const objectRes = response.data.data;
          console.warn("fdgdfgdggfgfhfhgj hjhjjhjhjh", objectRes);
          setpaginate(response.data.pagination);
          var count = paginate * 10;

          setloadbuttonshow(count);
          let merged = firstNumbers.concat(objectRes);
          let mer = users.concat(objectRes);
          setUsers(mer);
        } else {
          let mer = [];
          setUsers(mer);
        }
      })
      .finally(() => {
        setLoadingwallet(false);
        setIsLoading(false);
      });
  };

  return (
    <>







      <Space>

        <Button
          type="primary"
          onClick={() => {
            Modal.confirm({
              title: 'Confirm',
              content: 'Bla bla ...',
              footer: (_, { Submit }) => (
                <>
                  <Submit />
                </>
              ),
            });
          }}
        >
          Open Modal Confirm
        </Button>
      </Space>
      {/* {showSubmitButton && */}
      <Modal
        open={open}
        title="Transfer"
        onOk={handleOk}
        className='model-transferpoint'
        onCancel={handleCancel}
        footer={(_, { }) => (
          <>
            {showSubmitButton && <Button className='submitform' onClick={transferpoints}>Submit</Button>}
          </>
        )}
      >
        <div className="logo d-flex justify-content-center w-100 logomodel">
          <img src={Logo} />
        </div>
        <p className='pointsid text-white p-2 text-center'>यहां से आप अपने POINT अपने दोस्तो की ID मैं डाल सकते हो</p>
        <Input placeholder="Enter Mobile Number" value={mobilnumber} onChange={OnnumberChange} type='number' maxLength={6} className={`form-control ${mobilnumbererror ? 'is-invalid' : ''} mb-2`} />
        {mobilnumbererror && (
          <div className="invalid-feedback">Please enter a valid Number</div>
        )}
        <Input placeholder="Amount" type='number' value={amounttr} onChange={OnamountChange} className={`form-control ${amounttrerror ? 'is-invalid' : ''}`} />
        {amounttrerror && (
          <div className="invalid-feedback">Please enter a valid Amount</div>
        )}
      </Modal>
      <section id="wallet" className="margin-bottom-88">
        <Container fluid className="p-0 margin-bottom-70">
          <div className="homecontainer">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first" className="w-100">
              <div className="">
                <div className='tabs_wallet'>
                  <Nav variant="pills" className="tabslinks">
                    <Nav.Item>
                      <Nav.Link eventKey="first" className='text-center AddPoint'>Add Point</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second" className='text-center Withdraw' onClick={app_manager}>Withdraw</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>

              </div>
              <div >
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <div className='tab_content_one position-relative'>
                      <div className='addfundwallet'>
                        <div className="bankicon">
                          <Icon.Bank />
                        </div>
                        <input
                          type="number"
                          value={inputValuedeposit}
                          onChange={(e) => {
                            // Ensure the input value is a number
                            const inputValue = parseInt(e.target.value, 10);

                            // Check if the input is a valid number and limit it to 5 digits
                            if (!isNaN(inputValue) && inputValue >= 0) {
                              setInputValuedeposit(inputValue.toString().slice(0, 4));
                            } else {
                              setInputValuedeposit('');
                            }
                          }}
                          required
                          className='form-control addamountinput'
                          placeholder='Enter Amount'
                        />

                      </div>
                      <div className='button-amount d-flex flex-wrap'>
                        <button className='btn-amount' onClick={() => handleButtonClickdeposit("50")}>₹ 50</button>
                        <button className='btn-amount' onClick={() => handleButtonClickdeposit("100")}>₹ 100</button>
                        <button className='btn-amount' onClick={() => handleButtonClickdeposit("200")}>₹ 200</button>
                        <button className='btn-amount' onClick={() => handleButtonClickdeposit("500")}>₹ 500</button>
                        <button className='btn-amount' onClick={() => handleButtonClickdeposit("1000")}>₹ 1000</button>
                      </div>
                      <p className="description mt-2 text-danger">{appmanager && appmanager.dep_message}</p>
                      <center>


                        {/* <h5>Win Amount :<strong>0</strong></h5> */}
                        <div className="d-flex justify-content-center my-2">
                          <button className='btnaddpoints w-50' onClick={handleDeposit} >
                            Add Points
                          </button>
                          {/* <button className='transferpoints' onClick={showModal}>
                            Transfer Points
                          </button> */}
                        </div>
                        <div className='d-flex justify-content-center radiobtn'>
                        </div>
                      </center>
                    </div>
                    <div className='table-responsive'>
                      <div style={{ textAlign: 'center' }}>
                        {depositvideoink && (
                          <a
                            href={depositvideoink}  // यह dynamic link है
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              textAlign: 'center',
                              marginTop: '0.5rem',
                              backgroundColor: '#007bff',
                              color: 'white',
                              padding: '10px 20px',
                              borderRadius: '5px',
                              display: 'inline-block',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              textDecoration: 'none',
                            }}
                          >
                            डिपॉजिट (Deposit) करने के लिए वीडियो देखें:
                          </a>
                        )}
                      </div>




                      <p className='text-center mt-2 requesthistory'> Add Points  History</p>

                      <div className="table-responsive">
                        <p className="text-center mt-2 requesthistory">
                          Wallet History
                        </p>

                        <Table striped bordered hover className="tablehistory">
                          <thead>
                            <tr>
                              <th>Sr No</th>
                              <th>Pay Mode</th>
                              <th>Date</th>
                              <th>Points </th>
                              <th>Closing Balance </th>
                              <th>Status </th>
                            </tr>
                          </thead>
                          <tbody className="position-relative">
                            {loadingwallet ? (
                              <>
                                <div className="loadernew">
                                  <img
                                    src={loading1}
                                    className="px-2 loaderfile"
                                    style={{ width: "50px" }}
                                    alt="Loading..."
                                  />
                                </div>
                              </>
                            ) : users.length > 0 ? (
                              users &&
                              users.map((values, index) => {
                                const dateTime = new Date(values.datetime);
                                const formattedDate = `${dateTime.getDate()}-${dateTime.getMonth() + 1
                                  }-${dateTime.getFullYear()} ${dateTime.getHours()}:${dateTime.getMinutes()}`;
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {values.remark} {values.market}
                                    </td>
                                    <td>{values.datetime}</td>
                                    <td>{values.amount}</td>
                                    <td>{values.closing_balance}</td>
                                    <td className="text-success">
                                      {" "}
                                      <span
                                        style={{
                                          color:
                                            values.status === "Success"
                                              ? "green"
                                              : "red",
                                        }}
                                      >
                                        {values.status}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  colSpan="10"
                                  className="text-center nodataavl"
                                >
                                  {" "}
                                  No data available or something went wrong.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                        {users && users.length >= loadbuttonshow ? (
                          <div className="d-flex justify-content-center loadmore">
                            <button
                              className="btn btn-primary w-50  mx-auto text-center"
                              onClick={shoot}
                            >
                              Load More Button
                            </button>
                          </div>
                        ) : null}
                      </div>


                      {/* {userspag && userspag.length > loadButtonShow && (
                          <div className="d-flex justify-content-center loadmore">
                            <button
                              className="btn btn-primary w-50 mx-auto text-center"
                              onClick={handleLoadMore}
                              disabled={loading}
                            >
                              {loading ? 'Loading...' : 'Load More'}
                            </button>
                          </div>
                        )} */}
                      {/* </div> */}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <div className='tab_content_one position-relative'>
                      <div className='addfundwallet'>
                        <div className="bankicon">
                          <Icon.Bank />
                        </div>
                        {/* <input type="Number" value={inputValue || point} onChange={(e) => setInputValue(e.target.value)} className={`form-control ${inputError ? 'is-invalid' : ''} addamountinput`}
                          placeholder='Withdraw' /> */}
                        <input
                          type="number"
                          // placeholder="Account Number"
                          value={inputValue || point}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setInputValue(newValue);

                            // Check if a new value is entered and clear accountno
                            if (newValue !== point) {
                              setPoint('');
                            }
                          }}
                          className={`form-control ${inputError ? 'is-invalid' : ''} addamountinput`}
                          placeholder='Enter Amount'
                        />
                        {/* {inputError && (
                          <div className="invalid-feedback">Please enter a valid amount (e.g., 500 or 500.00)</div>
                        )} */}
                      </div>
                      <div className='button-amount d-flex flex-wrap'>
                        <button className='btn-amount' onClick={() => handleButtonClick("500")}>₹ 500</button>
                        <button className='btn-amount' onClick={() => handleButtonClick("1000")}>₹ 1000</button>
                        <button className='btn-amount' onClick={() => handleButtonClick("2000")}>₹ 2000</button>
                        <button className='btn-amount' onClick={() => handleButtonClick("5000")}>₹ 5000</button>
                      </div>
                      <center>







                        {/* <p className="description mt-2 text-danger text-center">{appmanager && appmanager.dep_message}</p> */}
                        <a
                          // href={withdraw_video_link}  
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textAlign: 'center',
                            marginTop: '0.5rem',
                            backgroundColor: '#007bff',
                            color: 'white',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            display: 'inline-block',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            textDecoration: 'none'
                          }}
                        >

                          {/*     विड्रॉल  (withdraw) करने के लिए वीडियो देखें: */}
                          <p>
                            Withdrawal Time:{" "}
                            {formatTime(appmanager?.withdraw_open_time)} to{" "}
                            {formatTime(appmanager?.withdraw_close_time)}
                          </p>


                        </a>

<p className="description mt-2 text-danger text-center">
  विथड्रावल डालने के 20  से 25 मिनट के अंदर आपके अकाउंट में पेमेंट आ जाएगी।
</p>                        <p className='text-center winamount marketnamelist'><h3 className='animationtittle markettitlenam'>Win Amount :- </h3> {winAmount}</p>
                        {/* <Button type="primary" onClick={showModalnew}>
                          Open Modal
                        </Button> */}

                        <div className="tab-container">
                          {/* Tab Buttons */}
                          <div className="tab-buttons">
                            <button
                              onClick={() => setActiveTab('bank')}
                              className={`tab-button ${activeTab === 'bank' ? 'active' : ''}`}
                            >
                              Bank
                            </button>
                            <button
                              onClick={() => setActiveTab('upi')}
                              className={`tab-button ${activeTab === 'upi' ? 'active' : ''}`}
                            >
                              UPI ID
                            </button>
                          </div>

                          {/* Tab Content */}
                          <div className="tab-content">
                            {activeTab === 'bank' && (
                              <div>
                                <Form
                                  form={form}
                                  layout="vertical"
                                  onFinish={onFinish}
                                  onFinishFailed={onFinishFailed}
                                  autoComplete="on"
                                  className=""
                                >

                                  <Form.Item

                                    className="mb-2"
                                    xl={24}
                                    rules={[
                                      { required: true, message: 'Account Number is required' },
                                      { type: 'string', message: 'Please enter a valid Account Number' }
                                    ]}
                                  >
                                    <Input
                                      type="number"
                                      placeholder="Account Number"
                                      value={accountNumber || accountno}
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        setAccountNumber(newValue);

                                        // Check if a new value is entered and clear accountno
                                        if (newValue !== accountno) {
                                          setAccountno('');
                                        }
                                      }}
                                      className={`form-control ${accountNumberError ? 'is-invalid' : ''}`}
                                    />

                                    {accountNumberError && (
                                      <div className="invalid-feedback">Please enter a valid account number (numbers only)</div>
                                    )}
                                  </Form.Item>
                                  <Form.Item
                                    className="mb-2"
                                    xl={24}
                                    rules={[{ required: true }, { type: 'uri', warningOnly: true }, { type: 'string' }]}
                                  >
                                    <Input
                                      type="number"
                                      placeholder="Confirm Account Number"
                                      autoComplete="on"
                                      value={accountNumberConfirmation || accountnoconf}
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        setAccountNumberConfirmation(newValue);

                                        // Check if a new value is entered and clear accountno
                                        if (newValue !== accountnoconf) {
                                          setAccountnoconf('');
                                        }
                                      }}
                                    // className={`form-control ${accountNumberError ? 'is-invalid' : ''}`}
                                    />

                                    {/* {accountNumberError && (
                              <div className="invalid-feedback">Please enter a valid account number (numbers only)</div>
                            )} */}
                                  </Form.Item>
                                  <Form.Item
                                    className="mb-2"
                                    xl={24}
                                    rules={[
                                      { required: true, message: 'IFSC code is required' }, // Ensure required rule is properly defined
                                      { type: 'string', message: 'Please enter a valid IFSC code' } // You might not need the type rule for IFSC code
                                    ]}
                                  >
                                    <Input
                                      type="text"
                                      placeholder="IFSC Code"
                                      className='text-transform-uppercase'
                                      autoComplete="on"
                                      maxLength={11}
                                      value={ifscCode || ifcecode}
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        setIfscCode(newValue);

                                        // Check if a new value is entered and clear ifcecode
                                        if (newValue !== ifcecode) {
                                          setIfcecode('');
                                        }
                                      }}
                                    // className={`form-control ${ifscCodeError ? 'is-invalid' : ''}`}
                                    // className={`form-control ${ifscCodeError ? 'is-invalid' : ''}`}
                                    />

                                    {ifscCodeError && (
                                      <div className="invalid-feedback">Please enter a valid IFSC code (e.g., ABCD1234567 And 11 Digit)</div>
                                    )}
                                  </Form.Item>

                                  <Form.Item
                                    className="mb-2"
                                    xl={24}
                                    rules={[{ required: true }, { type: 'uri', warningOnly: true }, { type: 'string' }]}
                                  >
                                    <Input
                                      type="text"
                                      maxLength={11}
                                      autoComplete="on"
                                      className='text-transform-uppercase'
                                      placeholder="Confirm IFSC Code"
                                      value={ifscCodeConfirmation || ifcecodeconf}
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        setIfscCodeConfirmation(newValue);

                                        // Check if a new value is entered and clear ifcecodeconf
                                        if (newValue !== ifcecodeconf) {
                                          // Perform the action to clear ifcecodeconf
                                          setIfcecodeconf(null); // Assuming ifcecodeconf is a state variable
                                        }
                                      }}
                                    />



                                    {/* {ifscCodeError && (
                              <div className="invalid-feedback">Please enter a valid IFSC code (e.g., ABCD1234567 And 11 Digit)</div>
                            )} */}
                                  </Form.Item>
                                  <Form.Item>
                                    {withdrawotp == 1 ? (

                                      <Space>
                                        <Button
                                          disabled={loadingbutton}
                                          type=""
                                          htmlType="submit"
                                          className='btn_color_all text-white refer-button'
                                          onClick={withdrawootp}
                                        >
                                          Withdrawal
                                          {/* model */}

                                        </Button>
                                      </Space>



                                    ) : (

                                      <Space
                                        onMouseEnter={app_manager} // Call app_manager on hover
                                        onMouseLeave={() => { }} // Optional: Handle mouse leave if needed
                                      >
                                        {showSubmitButton && (
                                          <Button
                                            disabled={loadingbutton}
                                            type=""
                                            htmlType="submit"
                                            className='btn_color_all text-white refer-button'
                                            onClick={handleWithdrawal}
                                          >
                                            Withdrawal
                                            {loadingbutton && (
                                              <Spinner
                                                animation="border"
                                                style={{ marginLeft: '5px', width: '15px', height: '15px', marginTop: "5px" }}
                                              />
                                            )}
                                          </Button>
                                        )}
                                      </Space>

                                    )}

                                    <p className='text-center text-danger mt-2'>Withdrawal Time:{" "}
                                      {formatTime(appmanager?.withdraw_open_time)} to{" "}
                                      {formatTime(appmanager?.withdraw_close_time)}</p>

                                  </Form.Item>
                                </Form>
                              </div>
                            )}
                            {activeTab === 'upi' && (
                              <div>
                                <h1 style={{ color: "#ffc107", fontSize: "20px", fontWeight: "600" }}> Enter your UPI ID</h1>
                                <Form.Item
                                  className="mb-2 mt-3"
                                  xl={24}
                                  rules={[
                                    { required: true, message: 'IFSC code is required' }, // Ensure required rule is properly defined
                                    { type: 'string', message: 'Please enter a valid IFSC code' } // You might not need the type rule for IFSC code
                                  ]}
                                >
                                  <Input
                                    type="text"
                                    placeholder="UPI ID"
                                    className='text-transform-uppercase'
                                    autoComplete="on"
                                    // maxLength={11}
                                    value={upiid}
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      setupiid(newValue);


                                    }}

                                  />
                                </Form.Item>
                                <Form.Item>
                                  {withdrawotp == 1 ? (

                                    <Space>
                                      <Button
                                        disabled={loadingbutton}
                                        type=""
                                        htmlType="submit"
                                        className='btn_color_all text-white refer-button'
                                        onClick={withdrawootp}
                                      >
                                        Withdrawal
                                        {/* model */}

                                      </Button>
                                    </Space>



                                  ) : (

                                    <Space
                                      onMouseEnter={app_manager} // Call app_manager on hover
                                      onMouseLeave={() => { }} // Optional: Handle mouse leave if needed
                                    >
                                      {showSubmitButton && (
                                        <Button
                                          disabled={loadingbutton}
                                          type=""
                                          htmlType="submit"
                                          className='btn_color_all text-white refer-button'
                                          onClick={handleWithdrawalupi}
                                        >
                                          Withdrawal
                                          {loadingbutton && (
                                            <Spinner
                                              animation="border"
                                              style={{ marginLeft: '5px', width: '15px', height: '15px', marginTop: "5px" }}
                                            />
                                          )}
                                        </Button>
                                      )}
                                    </Space>

                                  )}

                                  <p className='text-center text-danger mt-2'>       <p className='text-center text-danger mt-2'>Withdrawal Time:{" "}
                                      {formatTime(appmanager?.withdraw_open_time)} to{" "}
                                      {formatTime(appmanager?.withdraw_close_time)}</p></p>
                              
                                </Form.Item>

                              </div>
                            )}
                          </div>
                        </div>
                        {withdrawotp == 1 && (
                          <>

                            <Modal
                              title="Enter OTP"
                              open={isModalOpen}
                              // onOk={handleOknew}
                              footer={null}
                              onCancel={handleCancelnew}
                            >
                              <div className='d-flex justify-content-between gap-2'>
                                <input
                                  className='w-100'
                                  type="text"
                                  placeholder='Please Enter otp '
                                  value={otp}
                                  onChange={(e) => setOtp(e.target.value)}
                                />
                                <Button onClick={handleWithdrawalupi}>Submit</Button>
                              </div>
                            </Modal>


                          </>
                        )}

                        {/* <h5>Win Amount :<strong>0</strong></h5> */}
                        <p className="text-  text-center">Bank Account Details</p>
                        <div className='d-flex justify-content-center radiobtn'>
                        </div>




                      </center>
                    </div>
                    <div className='table-responsive'>
                      <p className='text-center mt-2 requesthistory'>Withdraw History</p>
                      <Table striped bordered hover className='tablehistory'>
                        <thead>
                          <tr>
                            <th>S No</th>
                            {/* <th>Pay Mode</th> */}
                            <th>Date</th>
                            <th>Points </th>
                            <th>Closing Balance </th>
                            <th>Status </th>
                          </tr>
                        </thead>
                        <tbody className='tbodyhistroy'>
                          {user.length > 0 ? (
                            user && user.map((value, index) => (
                              <tr>
                                <td>{index + 1}</td>
                                {/* <td>{value.value_update_by}</td> */}
                                <td>{value.date} </td>
                                <td>{value.tr_value}</td>
                                <td>{value.tr_value_updated}</td>
                                <td className='text-success'> <span style={{ color: value.tr_status === 'Success' ? 'green' : 'red' }}>{value.tr_status}</span></td>
                              </tr>

                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className='text-center nodataavl'> {msg}</td>
                            </tr>
                          )}

                          {
                            loadingwithdraw && (
                              <div className="spinner-wrapper">
                                <div className="loadernew">
                                  <img src={loading1} className="px-2 loaderfile" style={{ width: '50px' }} alt="Loading..." />
                                </div>
                              </div>
                            )
                          }
                        </tbody>
                        {/* <div className="loadernew">
                              <img src={loading1} className="px-2 loaderfile"  alt="Loading..." />
                            </div> */}

                      </Table>
                    </div>
                  </Tab.Pane>

                </Tab.Content>
              </div>

            </Tab.Container>
          </div>
        </Container >
        <ToastContainer />

      </section >
      {loading2 && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )
      }
      {
        loading3 && (
          <div className="spinner-wrapper">
            <div className="loadernew2"></div>
          </div>
        )
      }


    </>
  )
}
